import {FormSelectItem} from "./form_inputs/form_select";
import {fmtAccountCode} from "../utils/numbers";
import {
	QualityFindingTypeEnum,
	QualityFindingOriginEnum,
	QualityFindingSeverityEnum,
	InterviewHealthEnum,
	InterviewExitRiskEnum,
	QualityFindingStatusEnum,
	QualityActionTypeEnum,
	QualityActionStatusEnum,
	TrainingRecordKindEnum,
	TrainingRecordAreaEnum,
	TrainingRecordStatusEnum,
	BankAccount,
	DocumentTopic,
	DocumentTopicRestControllerApiFactory,
	BankAccountRestControllerApiFactory,
	AccountingAccount,
	AccountingAccountAccountTypeEnum,
	AccountingAccountNatureEnum,
	AccountingPeriodOfficialSourceEnum,
	AccountingAccountRestControllerApiFactory,
	AccountingPeriod,
	AccountingPeriodRestControllerApiFactory,
	AccountingRuleEventEnum,
	BankMovementMovementTypeEnum,
	JournalEntryOriginEnum,
	VatBookBookTypeEnum,
	AdminSharedRestControllerApiFactory,
	ApplicantState,
	ApplicantStateRestControllerApiFactory,
	BillDiscount,
	BillDiscountRestControllerApiFactory,
	BillInvoiceTypeEnum,
	BillRestControllerApiFactory,
	BillPaymentMethodEnum,
	SepaMandateSchemeEnum,
	SepaMandateStatusEnum,
	Budget,
	BudgetRestControllerApiFactory,
	Candidate,
	CandidateEventTypeEnum,
	CandidateLevelTest,
	CandidateLevelTestRestControllerApiFactory,
	CandidateRestControllerApiFactory,
	CandidateSource,
	CandidateSourceRestControllerApiFactory,
	CandidateState,
	CandidateStateRestControllerApiFactory,
	CandidateType,
	CandidateTypeRestControllerApiFactory,
	CandidateWorkTypeEnum,
	Configuration,
	Customer,
	EmpEvaluationRestControllerApiFactory,
	EmployeeRestControllerApiFactory,
	EmpUploadRestControllerApiFactory,
	EvaluationPoint,
	EvaluationPointRestControllerApiFactory,
	EvaluationResult,
	EvaluationResultRestControllerApiFactory,
	FixedAssetAmortizationMethodEnum,
	FixedAssetStatusEnum,
	HolidayCalendarEnum,
	OrganizationUnit,
	OrganizationUnitRestControllerApiFactory,
	PayrollPackTypeEnum,
	PermissionRolEnum,
	SharedPerson,
	PersonDocumentType,
	PersonWorkModeEnum,
	PersonDocumentRetentionBasisEnum,
	PersonDocumentTypeExpirationModeEnum,
	PersonDocumentTypeRequiredPeriodEnum,
	DocumentRolesEnum,
	DocumentAccessesEnum,
	CompanyExpiryCategoryEnum,
	PersonDocumentTypeRestControllerApiFactory,
	Recruitment,
	RecruitmentRestControllerApiFactory,
	RecruitmentStatusEnum,
	SalaryRoleEnum,
	SalaryRoleLevelEnum,
	Skill,
	SkillLevel,
	SkillLevelRestControllerApiFactory,
	SkillRestControllerApiFactory,
	Organization,
	OrganizationRestControllerApiFactory,
	CrmContactList,
	ContactRestControllerApiFactory,
	ListContactTypeEnum,
	ContactEventTypeEnum,
	LeadStatusEnum,
	LeadInOperationEnum,
	LeadMaintainedByEnum,
	LeadCommercialEmailBasisEnum,
	OrganizationStatusEnum,
	OrgRequestStatusEnum,
	LeadSourceEnum,
	SocialAccountProviderEnum,
	SocialAccountStatusEnum,
	SocialPostStatusEnum,
	Supplier,
	SupplierRestControllerApiFactory,
	SupportPoint,
	SupportPointRestControllerApiFactory,
	SupportResult,
	SupportResultRestControllerApiFactory,
	TaxSubmissionModelTypeEnum,
	TaxSubmissionStatusEnum,
	Template,
	TemplateRestControllerApiFactory,
	TrainingLevel,
	TrainingLevelRestControllerApiFactory,
	UserAuthItemTypeEnum,
	VacationStateEnum,
	VacationTypeEnum,
	BudgetKindEnum,
	BudgetBillingPeriodEnum,
	BudgetDeliveryAcceptanceEnum,
	WorkCenter,
	WorkCenterRestControllerApiFactory,
} from "arteco-api-client-ts";
import {ApiManager, useApiManager} from "../utils/api";
import {COUNTRIES_DATA, SPAIN_REGIONS_DATA} from "../utils/countries";
import {CANDIDATE_EVENT_TYPE, RECRUITMENT_STATUS} from "../../pages/admin/recruitment/labels";
import {CALENDAR_LABELS} from "../../pages/admin/employee/holiday/labels";
import {WORK_MODE_LABELS} from "../../pages/admin/employee/person/labels";
import {RETENTION_BASIS_LABELS} from "../../pages/admin/compliance/retention/labels";
import {EXPIRATION_MODE_LABELS, REQUIRED_PERIOD_LABELS} from "../../pages/admin/employee/persondoctype/labels";
import {MANAGEMENT_ROLES} from "../layout/shared/management_roles";
import {EXPIRY_CATEGORY_LABELS} from "../../pages/admin/compliance/expiry/labels";
import {USER_TYPE} from "../../pages/admin/config/labels";
import {VACATION_STATE, VACATION_TYPE_LABELS} from "../../pages/employee/vacation/labels";
import {TRAINING_KIND_LABELS, TRAINING_STATUS} from "../../pages/admin/employee/training/labels";
import {BUDGET_KIND_LABELS} from "../../pages/admin/billing/bill/labels";
import {TAX_MODEL_LABEL, TAX_STATUS} from "../../pages/admin/accounting/tax_submission/labels";
import {CONTACT_EVENT_TYPE, CONTACT_TYPE, LEAD_SOURCE, LEAD_STATUS} from "../../pages/admin/marketing/labels";

export interface TypeConf<T> {
	supplier: (apiManager: ApiManager, term?: string) => Promise<T[]>;
	valuer: (bean: T) => string | number;
	labeler: (bean: T) => string;
	isEnum?: boolean;
}

export interface TypeManager<T> {
	finalValue(selectedItems: T[]): T | T[];

	selected(selectedItems: T[], item: T): boolean;

	select(selectedItems: T[], item: T): T[];
}

export interface Typer<T> {
	supplier: (term?: string) => Promise<T[]>;
	typeManager: TypeManager<T>;
}

export function useType<T>(type: TypeConf<T>, multiple?: boolean): Typer<T> {
	const apiManager = useApiManager();
	return {
		supplier: (term) => type.supplier(apiManager, term),
		typeManager: getTypeManger(type, multiple),
	} as Typer<T>;
}

/**
 * Etiqueta en español de un valor de enum en los desplegables (#13893), sacada de los mapas de cada zona
 * (`labels.ts`). Si falta, el valor tal cual, como antes.
 */
const labelOf = (map: Record<string, string | { label: string }>, bean: FormSelectItem): string => {
	const l = map[bean.value as string];
	return typeof l === "string" ? l : l?.label || bean.label;
};

export const types = {
	discounts: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				BillDiscountRestControllerApiFactory
			);
			return service.listBillDiscount(term).then((resp) => resp.data);
		},
		labeler: (discount) => discount.name,
		valuer: (discount) => discount.id,
	} as TypeConf<BillDiscount>,

	budgets: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				BudgetRestControllerApiFactory
			);
			return service.listBudget(term).then((resp) => resp.data);
		},
		labeler: (budget) => budget.id
			? (budget.customer ? budget.customer.shortName + " - " : "") + budget.title + " " + (budget.totalHours + "h")
			: "",
		valuer: (budget) => budget.id,
	} as TypeConf<Budget>,

	budgetsUncompleted: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				BudgetRestControllerApiFactory
			);
			return service.listBudget(term).then((resp) => resp.data
			.filter(s => s.completed != true));
		},
		labeler: (budget) => budget.id
			? (budget.customer ? budget.customer.shortName + " - " : "") + budget.title + " " + (budget.totalHours + "h")
			: "",
		valuer: (budget) => budget.id,
	} as TypeConf<Budget>,

	templates: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				TemplateRestControllerApiFactory
			);
			return service.listTemplate(term).then((resp) => resp.data);
		},
		labeler: (template) => template.name,
		valuer: (template) => template.id,
	} as TypeConf<Template>,

	organizationUnits: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				OrganizationUnitRestControllerApiFactory
			);
			return service.listOrganizationUnit(term).then((resp) => resp.data);
		},
		labeler: (organizationUnit) => organizationUnit.name,
		valuer: (organizationUnit) => organizationUnit.id,
	} as TypeConf<OrganizationUnit>,

	customers: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				AdminSharedRestControllerApiFactory
			);
			return service.retrieveCustomers(term).then((resp) => resp.data);
		},
		labeler: (bean) => {
			let name = bean.shortName;
			if (name && bean.skipDedications) {
				name += " (V)";
			}
			return name;
		},
		valuer: (bean) => bean?.id,
	} as TypeConf<Customer>,

	people: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				AdminSharedRestControllerApiFactory
			);
			return service.retrievePeople(term).then((resp) => resp.data);
		},
		labeler: (bean) => {
			let res = bean.surnamesAndName;
			if (bean.id && bean.dismissed) {
				res = res + " (baja)";
			}
			return res;
		},
		valuer: (bean) => bean?.id,
	} as TypeConf<SharedPerson>,

	documentTopics: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				DocumentTopicRestControllerApiFactory
			);
			return service.listDocumentTopic(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean?.id,
	} as TypeConf<DocumentTopic>,

	personDocumentTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				PersonDocumentTypeRestControllerApiFactory
			);
			return service.listPersonDocumentType(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean?.id,
	} as TypeConf<PersonDocumentType>,

	personDocumentTypesAsEmployee: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				EmpUploadRestControllerApiFactory
			);
			return service.getEmployeeUploadTypes().then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean?.id,
	} as TypeConf<PersonDocumentType>,

	recruitmentStatus: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(RecruitmentStatusEnum, term));
			});
		},
		labeler: (bean) => labelOf(RECRUITMENT_STATUS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	role: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SalaryRoleEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	roleLevel: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SalaryRoleLevelEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	calendars: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(HolidayCalendarEnum, term));
			});
		},
		labeler: (bean) => labelOf(CALENDAR_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	expiryCategories: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(CompanyExpiryCategoryEnum, term));
			});
		},
		labeler: (bean) => labelOf(EXPIRY_CATEGORY_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/** Roles del sistema de gestión (#13911), con las etiquetas del admin. */
	managementRoles: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				// Por la etiqueta en español: el valor (QUALITY_COORDINATOR) no es lo que se teclea.
				const t = (term || "").toLowerCase();
				resolve(MANAGEMENT_ROLES.filter(r => r.value in DocumentRolesEnum && r.label.toLowerCase().includes(t))
					.map(r => ({value: r.value, label: r.label} as FormSelectItem)));
			});
		},
		labeler: (bean) => labelOf(Object.fromEntries(MANAGEMENT_ROLES.map(r => [r.value, r.label])), bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/** Roles de acceso a la aplicación a los que se dirige un documento (#14127): los de administración por área. */
	documentAccesses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				const t = (term || "").toLowerCase();
				resolve(Object.keys(DocumentAccessesEnum)
					.filter(v => v.startsWith("ADMIN_") && (USER_TYPE[v] || v).toLowerCase().includes(t))
					.map(v => ({value: v, label: USER_TYPE[v] || v} as FormSelectItem)));
			});
		},
		labeler: (bean) => labelOf(USER_TYPE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	retentionBases: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(PersonDocumentRetentionBasisEnum, term));
			});
		},
		labeler: (bean) => labelOf(RETENTION_BASIS_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	expirationModes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(PersonDocumentTypeExpirationModeEnum, term));
			});
		},
		labeler: (bean) => labelOf(EXPIRATION_MODE_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	requiredPeriods: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(PersonDocumentTypeRequiredPeriodEnum, term));
			});
		},
		labeler: (bean) => labelOf(REQUIRED_PERIOD_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	workModes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(PersonWorkModeEnum, term));
			});
		},
		labeler: (bean) => labelOf(WORK_MODE_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	workTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(CandidateWorkTypeEnum, term));
			});
		},
		labeler: (bean) => {
			switch (bean.label) {
				case CandidateWorkTypeEnum.FULL_DAY:
					return 'Jornada completa';
				case CandidateWorkTypeEnum.PART_DAY:
					return 'Jornada parcial';
				case CandidateWorkTypeEnum.PRACTICE:
					return 'Prácticas';
				default:
					throw "Tipo de jornada no reconocido " + bean.label;
			}
		},
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	candidateEventTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(CandidateEventTypeEnum, term));
			});
		},
		labeler: (bean) => labelOf(CANDIDATE_EVENT_TYPE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,


	applicantStatus: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				ApplicantStateRestControllerApiFactory
			);
			return service.listApplicantState(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<ApplicantState>,

	candidateTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				CandidateTypeRestControllerApiFactory
			);
			return service.listCandidateType(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<CandidateType>,

	candidateStates: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				CandidateStateRestControllerApiFactory
			);
			return service.listCandidateState(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<CandidateState>,

	userTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(UserAuthItemTypeEnum, term));
			});
		},
		labeler: (bean) => labelOf(USER_TYPE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	userPermission: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(PermissionRolEnum, term));
			});
		},
		labeler: (bean) => labelOf(USER_TYPE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	payrollPackType: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(PayrollPackTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	sources: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				CandidateSourceRestControllerApiFactory
			);
			return service.listCandidateSource(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<CandidateSource>,

	countries: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				const countries = term
					? COUNTRIES_DATA.filter((country) => country.label.indexOf(term) >= 0)
					: COUNTRIES_DATA;

				resolve(countries);
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	regions: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				const regions = term
					? SPAIN_REGIONS_DATA.filter((region) => region.label.indexOf(term) >= 0)
					: SPAIN_REGIONS_DATA;

				resolve(regions);
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	trainingLevels: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				TrainingLevelRestControllerApiFactory
			);
			return service.listTrainingLevel(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<TrainingLevel>,

	employeeTrainingLevels: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				EmployeeRestControllerApiFactory
			);
			return service.getEmployeeTrainingLevels().then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<TrainingLevel>,

	employeeWorkCenters: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				EmployeeRestControllerApiFactory
			);
			return service.getEmployeeWorkCenters().then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<WorkCenter>,

	workCenters: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				WorkCenterRestControllerApiFactory
			);
			return service.listWorkCenter(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<WorkCenter>,

	skills: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, SkillRestControllerApiFactory);
			return service.listSkill(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<Skill>,

	skillLevels: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				SkillLevelRestControllerApiFactory
			);
			return service.listSkillLevel(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<SkillLevel>,

	evaluationPoint: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, EvaluationPointRestControllerApiFactory);
			return service.listEvaluationPoint(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<EvaluationPoint>,

	evaluationPointAsEmployee: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, EmpEvaluationRestControllerApiFactory);
			return service.getEvaluationPoints().then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<EvaluationPoint>,

	evaluationResult: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				EvaluationResultRestControllerApiFactory
			);
			return service.listEvaluationResult(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<EvaluationResult>,

	evaluationResultAsEmployee: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, EmpEvaluationRestControllerApiFactory);
			return service.getPointResults().then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<EvaluationResult>,

	supportPoint: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, SupportPointRestControllerApiFactory);
			return service.listSupportPoint(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<SupportPoint>,

	supportResult: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				SupportResultRestControllerApiFactory
			);
			return service.listSupportResult(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.id,
	} as TypeConf<SupportResult>,

	vacationState: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(VacationStateEnum, term));
			});
		},
		labeler: (bean) => labelOf(VACATION_STATE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	findingTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(QualityFindingTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	findingOrigins: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(QualityFindingOriginEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	// Entrevistas periódicas (#13808): semáforo de salud y riesgo de salida.
	interviewHealths: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(InterviewHealthEnum, term));
			});
		},
		labeler: (bean) => INTERVIEW_HEALTH_LABELS[bean.value as string] || bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	interviewExitRisks: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(InterviewExitRiskEnum, term));
			});
		},
		labeler: (bean) => INTERVIEW_EXIT_RISK_LABELS[bean.value as string] || bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	findingSeverities: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(QualityFindingSeverityEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	findingStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(QualityFindingStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	qualityActionTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(QualityActionTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	qualityActionStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(QualityActionStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	trainingKinds: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(TrainingRecordKindEnum, term));
			});
		},
		labeler: (bean) => labelOf(TRAINING_KIND_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	trainingAreas: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(TrainingRecordAreaEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	trainingStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(TrainingRecordStatusEnum, term));
			});
		},
		labeler: (bean) => labelOf(TRAINING_STATUS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	budgetKind: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(BudgetKindEnum, term));
			});
		},
		labeler: (bean) => labelOf(BUDGET_KIND_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	deliveryAcceptance: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(BudgetDeliveryAcceptanceEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	billingPeriod: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(BudgetBillingPeriodEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	vacationType: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(VacationTypeEnum, term));
			});
		},
		labeler: (bean) => labelOf(VACATION_TYPE_LABELS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	candidates: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				CandidateRestControllerApiFactory
			);
			return service.listCandidate(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.surnamesAndName
			+ (bean.type ? " (" + bean.type.name + ")" : "") + " "
			+ (bean.source ? " (" + bean.source.label + ")" : ""),
		valuer: (bean) => bean.id,
	} as TypeConf<Candidate>,

	candidateLevelTests: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				CandidateLevelTestRestControllerApiFactory
			);
			return service.listCandidateLevelTest(term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<CandidateLevelTest>,

	recruitment: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(
				apiManager,
				RecruitmentRestControllerApiFactory
			);
			return service.listRecruitment(undefined, term).then((resp) => resp.data);
		},
		labeler: (bean) => bean.title,
		valuer: (bean) => bean.id,
	} as TypeConf<Recruitment>,

	accountingAccounts: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, AccountingAccountRestControllerApiFactory);
			const hasText = term && term.trim().length > 0;
			return service.listAccountingAccount(
				undefined, undefined, undefined, undefined, undefined,
				hasText ? undefined : true,
				hasText ? term : undefined,
				false
			).then((resp) => resp.data);
		},
		labeler: (bean) => {
			const base = bean.code && bean.name ? `${fmtAccountCode(bean.code)} - ${bean.name}` : (fmtAccountCode(bean.code) ?? bean.name ?? "");
			const entity = (bean as any).customer?.name ?? (bean as any).supplier?.name;
			return entity ? `${base} (${entity})` : base;
		},
		valuer: (bean) => bean.id,
	} as TypeConf<AccountingAccount>,

	accountingPeriods: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, AccountingPeriodRestControllerApiFactory);
			return service.listAccountingPeriod(undefined, undefined, term, false).then((resp) => resp.data);
		},
		labeler: (bean) => bean.yearValue && bean.name ? `${bean.yearValue} - ${bean.name}` : (bean.name ?? String(bean.yearValue ?? "")),
		valuer: (bean) => bean.id,
	} as TypeConf<AccountingPeriod>,

	suppliers: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, SupplierRestControllerApiFactory);
			return service.listSupplier(undefined, term, false).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name,
		valuer: (bean) => bean.id,
	} as TypeConf<Supplier>,

	accountingAccountTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(AccountingAccountAccountTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	accountingSources: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(AccountingPeriodOfficialSourceEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	accountingNatures: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(AccountingAccountNatureEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	accountingRuleEvents: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(AccountingRuleEventEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	journalOrigins: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(JournalEntryOriginEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	bankMovementTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(BankMovementMovementTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	vatBookTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(VatBookBookTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	amortizationMethods: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(FixedAssetAmortizationMethodEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	fixedAssetStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(FixedAssetStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	taxModelTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(TaxSubmissionModelTypeEnum, term));
			});
		},
		labeler: (bean) => labelOf(TAX_MODEL_LABEL, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	taxSubmissionStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(TaxSubmissionStatusEnum, term));
			});
		},
		labeler: (bean) => labelOf(TAX_STATUS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	bankAccounts: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, BankAccountRestControllerApiFactory);
			return service.listBankAccount(undefined, term, false).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name ?? "",
		valuer: (bean) => bean.id,
	} as TypeConf<BankAccount>,

	organizations: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, OrganizationRestControllerApiFactory);
			// listOrganization(status, baja, term, showDismissed): status y baja se colaron delante
			// de term al añadirse a OrganizationFilters (#11784). Van explícitos para que se vea.
			return service.listOrganization(undefined, undefined, term, false).then((resp) => resp.data);
		},
		labeler: (bean) => bean.name ?? "",
		valuer: (bean) => bean.id,
	} as TypeConf<Organization>,

	contacts: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, ContactRestControllerApiFactory);
			return service.listContact(undefined, undefined, undefined, undefined, term, false).then((resp) => resp.data);
		},
		labeler: (bean) => bean.surnamesAndName ?? bean.name ?? "",
		valuer: (bean) => bean.id,
	} as TypeConf<CrmContactList>,

	contactTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(ListContactTypeEnum, term));
			});
		},
		labeler: (bean) => labelOf(CONTACT_TYPE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	contactEventTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(ContactEventTypeEnum, term));
			});
		},
		labeler: (bean) => labelOf(CONTACT_EVENT_TYPE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	leadStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(LeadStatusEnum, term));
			});
		},
		labeler: (bean) => labelOf(LEAD_STATUS, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	// Cualificación del lead (#11788): los cuatro datos que el proceso manda preguntar antes de
	// presupuestar. Nacen NULL — «sin preguntar» es distinto de «no» — así que ninguno de los dos
	// es obligatorio en el formulario.
	leadOperationStages: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(LeadInOperationEnum, term));
			});
		},
		labeler: (bean) => labelOf({EN_OPERACION: "En operación", NO_ARRANCADO: "No arrancado"}, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/**
	 * Base legal del correo comercial (#13647): la misma para leads y contactos. Vacío es «sin
	 * revisar», distinto de NONE; a efectos de envío cuenta como sin base.
	 */
	commercialEmailBases: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(LeadCommercialEmailBasisEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	leadMaintainers: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(LeadMaintainedByEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/**
	 * Formas de cobro (#12844). Vale igual para la factura y para el defecto del cliente: los
	 * valores son los mismos y el generador crea un enum por cada sitio donde aparece.
	 */
	paymentMethods: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(BillPaymentMethodEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/** Facturas, para elegir a cuál rectifica una rectificativa (#13098). */
	bills: {
		supplier: (apiManager: ApiManager, term?: string) => {
			const [service] = prepareConfig(apiManager, BillRestControllerApiFactory);
			// Posicional: advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term.
			return service.listBill(undefined, undefined, undefined, undefined, undefined, undefined, undefined, term)
						  .then((resp) => resp.data);
		},
		labeler: (bean) => (bean ? `${bean.number} · ${bean.customer?.name ?? ""}` : ""),
		valuer: (bean) => bean?.id,
	} as TypeConf<any>,

	/** Tipo de factura de VERI*FACTU (#13059): F1 normal; R1-R5 rectificativas. */
	invoiceTypes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(BillInvoiceTypeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/** Estado del mandato SEPA (#12845): ACTIVO, REVOCADO o CADUCADO. */
	sepaMandateStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SepaMandateStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	/** Esquema del adeudo: CORE por defecto, B2B solo si un cliente lo exige. */
	sepaSchemes: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SepaMandateSchemeEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	organizationStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(OrganizationStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	orgRequestStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(OrgRequestStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	leadSources: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(LeadSourceEnum, term));
			});
		},
		labeler: (bean) => labelOf(LEAD_SOURCE, bean),
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	socialProviders: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SocialAccountProviderEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	socialAccountStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SocialAccountStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,

	socialPostStatuses: {
		supplier: (apiManager: ApiManager, term?: string) => {
			return new Promise<FormSelectItem[]>((resolve) => {
				resolve(enumToItems(SocialPostStatusEnum, term));
			});
		},
		labeler: (bean) => bean.label,
		valuer: (bean) => bean.value,
		isEnum: true,
	} as TypeConf<FormSelectItem>,
};

function prepareConfig<T>(
	apiManager: ApiManager,
	serviceClazz: (config: Configuration) => T
): [T] {
	const service: T = apiManager.factory(serviceClazz);
	return [service];
}

export const INTERVIEW_HEALTH_LABELS: Record<string, string> = {
	GREEN: "Verde",
	AMBER: "Ámbar",
	RED: "Rojo",
};

export const INTERVIEW_EXIT_RISK_LABELS: Record<string, string> = {
	LOW: "Bajo",
	MEDIUM: "Medio",
	HIGH: "Alto",
};

export const enumToItems = (enumType: any, term?: string): FormSelectItem[] => {
	const newTypes: FormSelectItem[] = [];
	Object.keys(enumType)
	.filter((value) => value.length >= 2)
	.filter((value) => !term || value.indexOf(term) >= 0)
	.forEach((value) => {
		newTypes.push({value: value, label: value} as FormSelectItem);
	});
	return newTypes;
};

class BaseTypeManager<T> {
	type: TypeConf<T>;
	multiple: boolean;

	constructor(type: TypeConf<T>, multiple?: boolean) {
		this.type = type;
		this.multiple = multiple || false;
	}

	finalValue(selectedItems: T[]): T | T[] {
		let result: T | T[] = [];
		if (this.multiple) {
			result = selectedItems;
		} else if (selectedItems.length) {
			result = selectedItems[0];
		}
		return result;
	}
}

class SimpleTypeManager<T> extends BaseTypeManager<T> implements TypeManager<T> {
	constructor(type: TypeConf<T>, multiple?: boolean) {
		super(type, multiple);
	}

	finalValue(selectedItems: T[]): T | T[] {
		return super.finalValue(selectedItems);
	}

	selected(selectedItems: T[], item: T): boolean {
		const value = this.type.valuer(item) as any as T;
		return selectedItems.find((i) => i == value) != undefined;
	}

	select(selectedItems: T[], item: T): T[] {
		const value = this.type.valuer(item) as any as T;

		let newSelection: T[];
		const lookedItem = selectedItems.find((i) => i == value);
		if (lookedItem) {
			// si existe se quita
			newSelection = selectedItems.filter((i) => i != value);
		} else {
			// si no existe
			newSelection = [value];
			if (this.multiple) {
				selectedItems.map((i) => newSelection.push(i));
			}
		}
		return newSelection;
	}
}

class ComplexTypeManager<T> extends BaseTypeManager<T> implements TypeManager<T> {
	constructor(type: TypeConf<T>, multiple?: boolean) {
		super(type, multiple);
	}

	finalValue(selectedItems: T[]): T | T[] {
		return super.finalValue(selectedItems);
	}

	selected(selectedItems: T[], item: T): boolean {
		return (
			selectedItems.find((i) => this.type.valuer(i) == this.type.valuer(item)) != undefined
		);
	}

	select(selectedItems: T[], item: T): T[] {
		let newSelection: T[];
		const lookedItem = selectedItems.find((i) => this.type.valuer(i) == this.type.valuer(item));
		if (lookedItem) {
			// si existe se quita
			newSelection = selectedItems.filter(
				(i) => this.type.valuer(i) != this.type.valuer(item)
			);
		} else {
			// si no existe
			newSelection = [item];
			if (this.multiple) {
				selectedItems.map((i) => newSelection.push(i));
			}
		}
		return newSelection;
	}
}

function getTypeManger<T>(type: TypeConf<T>, multiple?: boolean): TypeManager<T> {
	if (type.isEnum) {
		return new SimpleTypeManager<T>(type, multiple);
	} else {
		return new ComplexTypeManager<T>(type, multiple);
	}
}
